import { Component, Vue, Watch } from 'vue-property-decorator';
import { CreateElement } from 'vue';
import env from '../../Api/env';

const SIMU_STUDIO_PATH = [
    'ies/diagram',
    'diagram',
    'gmm',
    'ies/run-simulation',
    'ies/run-optimization',
    'scenario-generate',
    'resilience-eval',
    'resilience-plan',
    'resilience-recovery',
];
@Component({})
export default class Diagram extends Vue {
    private src = '/model/admin/ies-simulation-454';
    get currentProject() {
        return this.$store.state.projects;
    }
    context = {};
    @Watch('$route.name', { immediate: true, deep: true })
    onOption(nVal: string, oVal: string): void {
        const url = new URL(`${this.src}`, env.projectUrl);
        if (nVal === 'diagram') {
            url.hash = `${this.context['currentComponent'] ?? '#/design/diagram/canvas/canvas_0'}`;
        } else if (nVal === 'ies/diagram') {
            url.hash = `${this.context['currentComponent'] ?? '#/design/diagram/canvas/canvas_0'}`;
        } else if (nVal === 'ies/run-simulation') {
            url.hash = `#/run/cases/${encodeURIComponent(
                `|function/CloudPSS/ieslab-simulation[${this.context['function/CloudPSS/ieslab-simulation'] ?? 0}]`,
            )}`;
        } else if (nVal === 'ies/run-optimization') {
            url.hash = `#/run/cases/${encodeURIComponent(
                `|function/CloudPSS/ieslab-optimization[${this.context['function/CloudPSS/ieslab-optimization'] ?? 0}]`,
            )}`;
        } else if (nVal === 'gmm') {
            url.hash = `#/run/cases/${encodeURIComponent(`|function/CloudPSS/ieslab-gmm[${this.context['function/CloudPSS/ieslab-gmm'] ?? 0}]`)}`;
        } else if (SIMU_STUDIO_PATH.includes(nVal)) {
            url.hash = `#/run/cases/${encodeURIComponent(`|function/CloudPSS/${nVal}[${this.context[`function/CloudPSS/${nVal}`] ?? 0}]`)}`;
        }
        this.src = url.href;
    }

    urlChange(): void {
        const iesMode = this.$store.state.iesMode ? 'ieslab-simulation' : 'ieslab-plan';
        if (this.currentProject != null && this.currentProject.model != null) {
            const url = new URL(`${this.currentProject.model}?simulation=${this.currentProject.id}&mode=${iesMode}`, env.projectUrl);
            this.src = url.href;
            this.onOption(this.$route.name ?? '', '');
        }
    }
    @Watch('currentProject', { deep: true })
    onProjectChanged(a, b) {
        this.urlChange();
    }

    parserHash(url: string): [string, [string, string], string] {
        const u = new URL(url);
        const s = u.hash.split('/');
        const hash = s[1];
        if (hash === 'run') {
            const p = decodeURIComponent(s[s.length - 1]);
            const [, jobFilter, jobIndex] = /([^/]+\/[^/]+\/[^/[]+)?\[(\d+)\]/.exec(p) ?? [];

            const jobRid = jobFilter.split('|')[1];
            return [s[1], [jobRid, jobIndex], ''];
        }
        return [s[1], ['', ''], u.hash];
    }
    onload() {
        this.$store.commit('setStudioIframe', this.$refs['iframe']);
        (this.$refs['iframe'] as HTMLIFrameElement).contentWindow?.addEventListener('hashchange', (e) => {
            const iesMode = this.$store.state.iesMode;
            const env = e as HashChangeEvent;
            const [newHash, job, hash] = this.parserHash(env.newURL);

            const query = this.$route.query;
            const routeName = this.$route.name;
            if (!['ies/diagram', 'diagram', 'gmm', 'ies/run-simulation', 'ies/run-optimization'].includes(routeName ?? '')) return;

            if (newHash === 'run') {
                const [oldHash, oldJob] = this.parserHash(env.oldURL);
                const [jobRid, jobIndex] = job;

                const [oldJobRid] = oldJob;
                this.context[jobRid] = jobIndex;
                if (jobRid === oldJobRid) return;

                if (jobRid === 'function/CloudPSS/ieslab-optimization') {
                    if (routeName === 'ies/run-optimization') return;
                    this.$router.push({ path: 'run-optimization', query });
                    return;
                } else if (jobRid === 'function/CloudPSS/ieslab-simulation') {
                    if (routeName === 'ies/run-simulation') return;
                    this.$router.push({ path: 'run-simulation', query });
                    return;
                } else if (jobRid === 'function/CloudPSS/ieslab-gmm') {
                    if (routeName === 'gmm') return;
                    this.$router.push({ path: 'gmm', query });
                    return;
                } else {
                    if (routeName && jobRid.endsWith(routeName)) return;
                    const p = jobRid.split('/')[2];
                    console.log(p);
                    this.$router.push({ path: p, query });
                    return;
                }
            } else if (newHash === 'design') {
                this.context['currentComponent'] = hash;
                if (routeName?.includes('diagram')) return;

                if (iesMode) {
                    this.$router.push({ path: 'diagram', query });
                } else {
                    this.$router.push({ path: 'diagram', query });
                }
            }
        });
    }

    render(_h: CreateElement) {
        return (
            <div style={{ width: '100%', height: '100%', overflow: 'clip' }}>
                <iframe
                    loading="lazy"
                    ref="iframe"
                    id="myIframe"
                    style={{ width: '100%', height: '100%' }}
                    srcolling="no"
                    src={this.src}
                    frameborder="0"
                    on-load={this.onload}
                />
            </div>
        );
    }
}
